import React from 'react'
import { DsRemixIcon, DsStack, DsTypography } from '@am92/react-design-system'

import { T_PAGE_CONTENT } from '../Types/StaticPage.Types'

interface IStaticContentProps {
  pageContent: T_PAGE_CONTENT[]
}

const StaticContent: React.FC<IStaticContentProps> = props => {
  const { pageContent } = props

  return (
    <DsStack
      direction='column'
      spacing={{
        xs: 'var(--ds-spacing-bitterCold)',
        lg: 'var(--ds-spacing-warm)'
      }}
    >
      {pageContent.map((content, contentIndex) => (
        <DsStack key={contentIndex} direction='column'>
          <DsTypography variant='headingBoldMedium'>
            {contentIndex + 1}. {content.TITLE}
          </DsTypography>

          {content.CONTENT.map((item, itemIndex) => {
            if (item.TYPE === 'TEXT') {
              return (
                <DsStack
                  key={itemIndex}
                  direction='column'
                  spacing='var(--ds-spacing-glacial)'
                >
                  {item.CONTENT.map((itemContent, itemContentIndes) => (
                    <DsTypography
                      key={itemContentIndes}
                      component='div'
                      variant='bodyRegularMedium'
                    >
                      {itemContent}
                    </DsTypography>
                  ))}
                </DsStack>
              )
            } else if (item.TYPE === 'LIST') {
              return (
                <DsStack
                  key={itemIndex}
                  direction='column'
                  spacing='var(--ds-spacing-glacial)'
                  sx={{
                    ml: {
                      xs: 'var(--ds-spacing-frostbite)',
                      md: 'var(--ds-spacing-mild)'
                    }
                  }}
                >
                  {item.CONTENT.map((itemContent, itemContentIndes) => (
                    <DsTypography
                      key={itemContentIndes}
                      component='div'
                      variant='bodyRegularMedium'
                    >
                      <DsRemixIcon
                        className='ri-circle-fill'
                        sx={{ fontSize: '10px' }}
                      />{' '}
                      {itemContent}
                    </DsTypography>
                  ))}
                </DsStack>
              )
            }
          })}
        </DsStack>
      ))}
    </DsStack>
  )
}

export default StaticContent
